import _ from 'lodash';
import { apiFetch, apiSearch, apiRemove } from '../utility';
const apiBase = 'ocrIngestion';

export const search = (p = {}) => {
	const { doNotIncludeOcrBlocks, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				doNotIncludeOcrBlocks,
			},
			dispatch,
			callback,
		});
	};
};

export const get = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.add`,
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const reRunOcr = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.reRunOcr`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getDebug = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getDebug`,
			params,
			dispatch,
			callback,
		});
	};
};

export const getAiV2Prompt = ({ callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.getAiV2Prompt`,
			params: {},
			dispatch,
			callback,
		});
	};
};

export const remove = ({ ocrIngestionId, callback = _.noop }) => {
	return (dispatch) => {
		apiRemove({
			base: apiBase,
			id: ocrIngestionId,
			dispatch,
			callback,
		});
	};
};
